import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LogEntry } from './log/log.action';
import { Store } from '@ngxs/store';
import { LogEntryModel } from '../../models/logentry';


// examples of usage the BannerService
// this.bannerService.info("info", "tytul");
// this.bannerService.error("error", "tytul");
// this.bannerService.success("sucess", "tytul");
// this.bannerService.warning("warning", "tytul");

@Injectable()
export class BannerService {

   constructor(public toastr: ToastrService,
               private store: Store
      ) {
   }

   public error(message: string, title?: string, dismissByTap: boolean = true) {
      this.toastr.error(message, title, {
         tapToDismiss: dismissByTap,
         disableTimeOut: dismissByTap,
         timeOut: 5000,
         enableHtml: true,
         onActivateTick: true
      });
      const errorEntry = new LogEntryModel();
      errorEntry.entry = `${title} - ${message}`;
      errorEntry.methodName = 'BannerService';
      errorEntry.type = 'error';
      this.store.dispatch(new LogEntry(errorEntry));
   }

   public instantMessage(message: string, title?: string, dismissByTap: boolean = true) {
      this.toastr.info(message, title, {
         tapToDismiss: dismissByTap,
         disableTimeOut: dismissByTap,
         timeOut: 500000,
         enableHtml: true,
         onActivateTick: true
      });
  }

  public instantError(message: string, title?: string, dismissByTap: boolean = true) {
    this.toastr.error(message, title, {
      tapToDismiss: dismissByTap,
      disableTimeOut: dismissByTap,
      timeOut: 500000,
      enableHtml: true,
      onActivateTick: true
    });
  }

  public instantSuccess(message: string, title?: string, dismissByTap: boolean = true) {
    this.toastr.success(message, title, {
      tapToDismiss: dismissByTap,
      disableTimeOut: dismissByTap,
      timeOut: 500000,
      enableHtml: true,
      onActivateTick: true
    });
  }

   public quickInfo(message: string) {
      this.toastr.info(message, null, {
         timeOut: 1150,
         onActivateTick: true
      });
   }

   public info(message: string, title?: string) {
      this.toastr.info(message, title, {
         onActivateTick: true
      });
   }

   public warning(message: string, title?: string) {
      this.toastr.warning(message, title, {
         onActivateTick: true
      });
   }

   public success(message: string, title?: string) {
      this.toastr.success(message, title, {
         onActivateTick: true
      });
   }
}
